import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { StoreState } from '../../../store/reducer-main';
import { Family, FamilyFormData } from '../../../types/families';
import PageLayout from '../../components/common/PageLayout';
import { Button } from '@nextui-org/react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FamilyForm from '../../components/others/forms/FamilyForm';
import theme from '../../theme';
import { getStringKeywords, ts2Age } from '../../../helpers/utils';
import { updateUserFamily } from '../../../service/families';
import { toast } from 'react-toastify';

export default function EditFamilyPage() {

  const navigate = useNavigate();
  const location = useLocation();

  const { userProfile } = useSelector((state: StoreState) => state.profile);

  const [loading, setLoading] = React.useState<boolean>(false);

  if (!location.state) {
    navigate('/famlies');
  }

  const getUpdatedFamilyData = (
    familyFormData: FamilyFormData,
    f: Family,
  ): Family => {
    const { name, surname } = familyFormData.personalData;
    const nameSurnameKeyword = getStringKeywords(name, surname);
    const ageMetadata = ts2Age(familyFormData.personalData.tsDateOfBirth);
    return {
      ...familyFormData,
      id: f.id,
      tsCreated: f.tsCreated,
      tsUpdated: Date.now(),
      assignedCaregiver: f.assignedCaregiver,
      metadata: {
        keywords: nameSurnameKeyword,
        normalizedSurname: surname.toLowerCase(),
        age: ageMetadata,
      }
    }
  }

  const submit = async(
    formData: FamilyFormData
  ) => {
    try {
      if (!userProfile) return;
      setLoading(true);
      const updatedData = getUpdatedFamilyData(formData, location.state);
      await updateUserFamily(userProfile.uid, updatedData);
      setLoading(false);
      toast.success('Famiglia modificata con successo');
      navigate(-1);
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <PageLayout nestedPage>
      <div className='flex justify-between items-center'>
        <div className='flex flex-row gap-4 items-center'>
          <Button isIconOnly aria-label="back" color='primary' size='sm' onClick={() => navigate(-1)} radius='full'>
            <ArrowBackIcon />
          </Button>
          <p className='text-xl font-medium'>Modifica Famiglia</p>
        </div>
      </div>
      <FamilyForm
        initialData={location.state}
        interviewMode
        className='mt-6 p-4'
        style={{
          borderRadius: theme.sizing.x2,
          backgroundColor: theme.color.background,
          border: '1.5px solid lightgray'
        }}
        loading={loading}
        onCancel={() => navigate(-1)}
        onSubmit={submit}/>
    </PageLayout>
  )
}